import React from "react";
import WorkspaceInternalControls from "../../libraries/WorkspaceInternalControls";

interface OthExpInternalControlsProps {
  onBack?: () => void;
  setActiveSection?: (section: string) => void;
  controlsListSection?: string;
}

export default function OthExpInternalControls({ onBack, setActiveSection, controlsListSection }: OthExpInternalControlsProps) {
  return (
    <WorkspaceInternalControls
      workspaceName="Other Expenses"
      onBack={onBack}
      setActiveSection={setActiveSection}
      controlsListSection={controlsListSection}
    />
  );
}


